module.exports = __webpack_public_path__ + "static/kuchnia-5952fcd4f1b6ca2550d1039b6015b080.jpg";